import { AutodataTrackingTypes, DataEvent } from "./ts/types";

import { capitalizeFirstLetter } from "@common/helpers/parseObjects";

/**
 *
 * data-event-type is not listened by autodata,
 * it's used to define the action name
 *
 * Example :
 * data-event-type = contact and the element was not opened
 * action name will be openToggleContact
 *
 * **/

export const getDataEvent = (
  htmlElement: HTMLElement,
  trackingTypes: AutodataTrackingTypes,
  params?
): DataEvent => {
  let dataEvent: DataEvent = {
    category: htmlElement.getAttribute("data-event-category"),
    action: htmlElement.getAttribute("data-event-action"),
    label: htmlElement.getAttribute("data-event-label"),
    value: htmlElement.getAttribute("data-event-value"),
    faqThematic: htmlElement.getAttribute("data-event-faq_thematic"),
    faqCategory: htmlElement.getAttribute("data-event-faq_category"),
    faqQuestion: htmlElement.getAttribute("data-event-faq_question"),
  };

  // When it's collapsible, get action name from attributes and state
  if (trackingTypes === AutodataTrackingTypes.pageView) {
    dataEvent.pageName = htmlElement.getAttribute("data-pageView-pageName");
  }

  // When it's collapsible, get action name from attributes and state
  if (trackingTypes === AutodataTrackingTypes.collapsible) {
    const actionType = params.action.hasBeenOpened
      ? "openToggle"
      : "closeToggle";

    dataEvent.action = `${actionType}${capitalizeFirstLetter(
      params.action.type
    )}`;
  }

  return dataEvent;
};
